import React, { useEffect, useState } from 'react';
import Translate from '../Translate/Translate';
import classNames from 'classnames';

interface Props {
  prices: PriceItem[];
  productNew?: boolean;
  containerClassName?: string;
  componentClassName?: string;
  hidePercentage?: boolean;
}

type PriceItem = {
  type: PriceType;
  value: number;
};

enum PriceType {
  Default = 'default',
  Sale = 'sale',
  Client = 'client',
  ClientExtra = 'client_extra',
  Campaign = 'campaign_sale',
}

const DiscountPercentage = ({
  prices = [],
  productNew,
  containerClassName,
  componentClassName,
  hidePercentage = false,
}: Props) => {
  const [minPrice, setMinPrice] = useState<PriceItem | null>(null);
  const [maxPrice, setMaxPrice] = useState<PriceItem | null>(null);
  const [hasDiscount, setHasDiscount] = useState<boolean>(false);

  useEffect(() => {
    if (prices.length === 0) {
      setMinPrice(null);
      setMaxPrice(null);
      setHasDiscount(false);
      return;
    }

    const min = prices.reduce((min, price) =>
      price.value < min.value ? price : min,
    );
    const max = prices.reduce((max, price) =>
      price.value > max.value ? price : max,
    );

    setMinPrice(min);
    setMaxPrice(max);
    setHasDiscount(prices.length > 1 && min.value !== max.value);
  }, [prices]);

  let discountCaption = null;

  if (hasDiscount) {
    const discountPercentage = Math.round(
      ((maxPrice.value - minPrice.value) / maxPrice.value) * 100,
    );

    // Only hide percentage if it's a client discount AND hidePercentage is true
    const shouldHidePercentage =
      hidePercentage &&
      (minPrice.type === PriceType.Client ||
        minPrice.type === PriceType.ClientExtra);

    discountCaption = (
      <div
        className={`${classNames(
          'text-xs mr-1 font-axi-bold py-1! text-center rounded-xl',
          {
            'bg-rgreen text-white w-12':
              !productNew &&
              (minPrice.type === PriceType.Client ||
                minPrice.type === PriceType.ClientExtra),
            'bg-ryellow text-black w-12':
              !productNew &&
              (minPrice.type === PriceType.Sale ||
                minPrice.type === PriceType.Campaign),
            'bg-rgreen! text-white w-20': productNew && !shouldHidePercentage,
            'bg-rgreen! text-white w-12': productNew && shouldHidePercentage,
          },
          minPrice.type,
        )}`}
      >
        <span>
          {productNew && shouldHidePercentage ? (
            <span className="uppercase">
              <Translate component="new-notification" keyword="notification" />
            </span>
          ) : productNew ? (
            <span className="uppercase">
              <Translate component="new-notification" keyword="notification" />
              {` | -${discountPercentage}%`}
            </span>
          ) : shouldHidePercentage ? (
            <span className="uppercase">
              <Translate component="new-notification" keyword="notification" />
            </span>
          ) : (
            `-${discountPercentage}%`
          )}
        </span>
      </div>
    );
  } else if (productNew) {
    discountCaption = (
      <div
        className={`${classNames(
          'text-xs mr-1 font-axi-bold py-1! text-center rounded-xl bg-rgreen! text-white w-12',
        )}`}
      >
        <span className="uppercase">
          <Translate component="new-notification" keyword="notification" />
        </span>
      </div>
    );
  }

  return (
    <div className={classNames('top-0', componentClassName)}>
      <div className={classNames('relative flex', containerClassName)}>
        {discountCaption}
      </div>
    </div>
  );
};

export default DiscountPercentage;
